module.exports = __webpack_public_path__ + "img/linus.19af03aa.jpg";